import { useEffect } from "react";

export function useDisableBodyScroll(disable) {
  useEffect(() => {
    document.body.style.overflowY = disable ? "hidden" : "scroll"
  }, [disable])
}